import {colorHelper} from "@/helpers/color-helper.js"
import {cssVar} from "@/helpers/misc"
import {canvasHelper} from "@/modules/canvas/canvas-helper.js"
import {measureNoteMarkdownWidth, segmentFont, wrapNoteMarkdownLines} from "@/modules/canvas/note-markdown.js"
import {canvasFont, colorDark, colorLight, fontSize} from "@/modules/canvas/styles.js"
import {CanvasItem} from "@/modules/canvas/table/CanvasItem.js"

export class Note extends CanvasItem {
    paddingY = fontSize * 1.25
    paddingX = fontSize * 1.25
    maxTextWidth = fontSize * 22

    constructor(canvas, data) {
        super(canvas, data)

        this.height = this.paddingY * 2 + fontSize
        if (this.ctx) this.measureContent()
        this.color = this.color || '#ffff00'
    }

    measureContent() {
        const previousFont = this.ctx.font
        this.ctx.font = canvasFont
        const content = this.data?.content ?? ""
        const lines = wrapNoteMarkdownLines(this.ctx, content, this.maxTextWidth)
        const contentWidth = measureNoteMarkdownWidth(this.ctx, lines)
        this.width = contentWidth + this.paddingX * 2
        this.height = this.paddingY * 2 + fontSize * lines.length
        this.ctx.font = previousFont
        return lines
    }

    draw() {
        const lines = this.measureContent()
        if (this.isOutOfScreen()) return

        this.update()

        this.ctx.beginPath()
        // rect
        this.ctx.fillStyle = this.color
        this.ctx.fillRect(this.left, this.top, this.width, this.height, this.borderRadius)
        this.ctx.fill()

        // text (inline **bold** and `code`)
        let color = this.color
        this.ctx.fillStyle = colorHelper.isLight(color) ? colorDark : colorLight

        lines.forEach((segments, idx) => {
            let x = this.left + this.paddingX
            const y = this.top + fontSize * idx + this.paddingY
            for (const seg of segments) {
                this.ctx.font = segmentFont(seg)
                if (seg.text) this.ctx.fillText(seg.text, x, y)
                x += this.ctx.measureText(seg.text).width
            }
        })

        let r = 4
        this.ctx.fillStyle = cssVar('--bg')
        canvasHelper.circle(this.ctx, this.left + r * 2, this.top + r * 2, r)
        this.ctx.fill()

        this.drawSelectedState()
        this.ctx.closePath()
    }
}
